import { Component, Input, OnInit } from '@angular/core';
import { DashboardService } from 'src/app/_services/dashboard/dashboard.service';

@Component({
  selector: 'app-recap',
  templateUrl: './recap.component.html',
  styleUrls: ['./recap.component.scss']
})
export class RecapComponent implements OnInit {

  @Input() value: number;
  @Input() title: string;
  @Input() subtitle: string;
  @Input() color: string;

  constructor(
    public dashboardService: DashboardService
  ) { }

  ngOnInit() {

  }

}
